import { Section } from "../models/sectionModel";
import { Element } from "../models/elementModel";
import { AppState } from "../reducers/rootReducer";

export const getAllRows = (state: AppState) => state.rowList;
export const getRowsByFormId = (formId: String) => (state: AppState) => { return state.rowList.filter((row) => row.formId === formId) };
export const getRowsByTabId = (tabId: String) => (state: AppState) => {
  return state.rowList.filter((row) => row.tabId === tabId);
};
export const getRowById = (id: String) => (state: AppState) => { return state.rowList.filter((row) => row.id === id) };
export const getSectionsByRowId = (id: String) => (state: AppState) => { return state.sectionList.filter((section) => section.rowId === id) };
export const getAllDependentsByRowId = (id: String) => (state: AppState) => {
    let elementList: Element[] = [];
    let sectionList: Section[] = state.sectionList.filter((section) => { return section.rowId === id });
    for (let index = 0; index < sectionList.length; index++) {
        const elementLisyBySectionId: Element[] = state.elementList.present.filter((element) => { return element.sectionId === sectionList[index].id });
        elementList = elementList.concat(elementLisyBySectionId);
    }
    return ({
        sectionList: sectionList,
        elementList: elementList
    })
}
